export const RECOVERY_WINDOW_MS = 60_000;

const RECOVERY_KEY_PREFIX = 'el.recovery.';

/**
 * Allows one automatic recovery (a redirect or a reload) per reason and key
 * within RECOVERY_WINDOW_MS, so a recovery that keeps failing stops instead of
 * looping. The attempt is kept in sessionStorage because a reload wipes memory.
 * When the attempt cannot be stored, recovery is refused rather than risking a
 * loop the guard could not see.
 */
export function attemptRecovery(
  reason: string,
  key: string,
  now: number = Date.now()
): boolean {
  const storageKey = `${RECOVERY_KEY_PREFIX}${reason}.${key}`;
  const stamp = String(now);

  try {
    const lastAttempt = Number(window.sessionStorage.getItem(storageKey));
    if (lastAttempt && now - lastAttempt < RECOVERY_WINDOW_MS) return false;

    window.sessionStorage.setItem(storageKey, stamp);
    return window.sessionStorage.getItem(storageKey) === stamp;
  } catch {
    return false;
  }
}
